import { EChartSeries } from '../types/series';

export const getSeriesTextMap: Partial<Record<EChartSeries, string>> = {
  [EChartSeries.CANDLESTICK]: 'Candlestick',
  [EChartSeries.LINE]: 'Line'
};
